import React from "react"

class CardDataType extends React.Component{
  constructor(props) {
    super(props);
  };

  render() {
    return (
      <p className="payment-log" style={{marginTop: '5px', marginBottom: '5px'}}>
        <span className={"credit-card-icon small " + this.props.data.brand}></span>
        {I18n.t('ending_in').toLowerCase()} {this.props.data.last_4}
      </p>
    );
  };

};

export default CardDataType